__turbopack_context__.v({
  "authorBio": "Article-module-scss-module__L1DKLW__authorBio",
  "authorImage": "Article-module-scss-module__L1DKLW__authorImage",
  "authorInfoContainer": "Article-module-scss-module__L1DKLW__authorInfoContainer",
  "authorName": "Article-module-scss-module__L1DKLW__authorName",
  "blogContent": "Article-module-scss-module__L1DKLW__blogContent",
  "blogContentContainer": "Article-module-scss-module__L1DKLW__blogContentContainer",
  "blogPostCategories": "Article-module-scss-module__L1DKLW__blogPostCategories",
  "blogPostDate": "Article-module-scss-module__L1DKLW__blogPostDate",
  "blogShareDivider": "Article-module-scss-module__L1DKLW__blogShareDivider",
  "blogSidebar": "Article-module-scss-module__L1DKLW__blogSidebar",
  "recentBlogsContainer": "Article-module-scss-module__L1DKLW__recentBlogsContainer",
});
